import { render } from "./OldSchoolContent.vue?vue&type=template&id=025c4e54&scoped=true"
import script from "./OldSchoolContent.vue?vue&type=script&lang=js"
export * from "./OldSchoolContent.vue?vue&type=script&lang=js"

import "./OldSchoolContent.vue?vue&type=style&index=0&id=025c4e54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025c4e54"]])

export default __exports__